import { render, staticRenderFns } from "./SetNewPasswordAfterLogin.vue?vue&type=template&id=0e8d06f8&"
import script from "./SetNewPasswordAfterLogin.vue?vue&type=script&lang=js&"
export * from "./SetNewPasswordAfterLogin.vue?vue&type=script&lang=js&"
import style0 from "./SetNewPasswordAfterLogin.vue?vue&type=style&index=0&id=0e8d06f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports